import { Create, List, Edit, Users, CourseUsersList, UserTraining } from "../Components/index.js";

export default [
    {
        path: "/training/career-plan-item",
        component: List,
        name: "training-career-plan-item",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/career-plan-item/create",
        component: Create,
        name: "training-career-plan-item-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/career-plan-item/:id/edit",
        component: Edit,
        name: "training-career-plan-item-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
